import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { LegalLayout, InfoBlock, type LegalSection } from "@/components/calv/LegalLayout";

const sections: LegalSection[] = [
  {
    id: "provider",
    num: "01",
    title: "Information according to § 5 TMG",
    content: (
      <InfoBlock>
        calvarius GmbH<br />
        Kalvarienberg 20<br />
        97753 Karlstadt<br />
        Germany
      </InfoBlock>
    ),
  },
  {
    id: "represented",
    num: "02",
    title: "Represented by",
    content: (
      <p>
        Managing Director: <strong>André Freier</strong>
      </p>
    ),
  },
  {
    id: "contact",
    num: "03",
    title: "Contact",
    content: (
      <InfoBlock>
        Phone: +49 9353 9768 000<br />
        Fax: +49 9353 9768 911<br />
        Email: <a href="mailto:info@calvarius.com">info@calvarius.com</a>
      </InfoBlock>
    ),
  },
  {
    id: "register",
    num: "04",
    title: "Commercial Register",
    content: (
      <p>
        Registered in the commercial register at Würzburg District Court<br />
        Registration number: <strong>HRB 11938</strong>
      </p>
    ),
  },
  {
    id: "tax",
    num: "05",
    title: "Tax Information",
    content: (
      <>
        <p>Tax number: 231/123/00058</p>
        <p>
          VAT identification number according to § 27 a of the German VAT Act:{" "}
          <strong>DE289667074</strong>
        </p>
      </>
    ),
  },
  {
    id: "responsible",
    num: "06",
    title: "Responsible for content according to § 55 Abs. 2 RStV",
    content: (
      <InfoBlock>
        André Freier<br />
        Kalvarienberg 20<br />
        97753 Karlstadt<br />
        Germany
      </InfoBlock>
    ),
  },
  {
    id: "liability-content",
    num: "07",
    title: "Liability for Content",
    content: (
      <p>
        The contents of our pages were created with the greatest care. However, we cannot
        guarantee the accuracy, completeness, and timeliness of the content. As a service
        provider, we are responsible for our own content on these pages according to legal
        regulations, but we are not obligated to monitor transmitted or stored third-party
        information or to investigate circumstances that indicate illegal activity.
      </p>
    ),
  },
  {
    id: "liability-links",
    num: "08",
    title: "Liability for Links",
    content: (
      <p>
        Our offer contains links to external third-party websites over whose content we have no
        influence. Therefore, we cannot accept any liability for this third-party content. The
        respective provider or operator of the linked pages is always responsible for their
        content.
      </p>
    ),
  },
  {
    id: "copyright",
    num: "09",
    title: "Copyright",
    content: (
      <p>
        The content and works created by the site operators on these pages are subject to German
        copyright law. Duplication, processing, distribution, and any kind of exploitation
        outside the limits of copyright law require the written consent of the respective author
        or creator.
      </p>
    ),
  },
  {
    id: "odr",
    num: "10",
    title: "Online Dispute Resolution Notice",
    content: (
      <>
        <p>
          The European Commission provides a platform for online dispute resolution (OS):{" "}
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            ec.europa.eu/consumers/odr
          </a>
          .
        </p>
        <p>
          We are not obligated and not willing to participate in dispute resolution proceedings
          before a consumer arbitration board.
        </p>
      </>
    ),
  },
];

export const Route = createFileRoute("/en/imprint")({
  head: () => {
    const h = pageHead("imprint", "en");
    return { meta: h.meta, links: h.links };
  },
  component: () => (
    <LegalLayout
      eyebrow="Imp."
      title="Imprint"
      meta="Information according to § 5 TMG"
      crumbLabel="Imprint"
      sections={sections}
      homeHref="/en"
      homeLabel="Home"
      tocLabel="Contents"
    />
  ),
});
